import { Component, OnInit } from '@angular/core';
import {ArmSession} from '../../login/login.component';
import {UserDataService} from '../../services/common/user-data/user-data.service';

@Component({
  selector: 'header-toolbar',
  templateUrl: './header-toolbar.component.html',
  styleUrls: ['./header-toolbar.component.scss']
})
export class HeaderToolbarComponent implements OnInit {

  name: string;

  constructor(private userDataService: UserDataService) { }

  ngOnInit(): void {
    const session: ArmSession = this.userDataService.getData();
    this.name = session.userName;
  }

}
